<script setup>
const load = window.loading
</script>

<template>
  <transition name="fade" class="animate__faster">
    <div class="loader" v-if="load">
      <div class="loading-box">
        <!-- <lottie-player src="/js/loader.json"  background="transparent"  speed="1" class="loading-image" loop autoplay></lottie-player> -->
        <!-- <div class="txt">Loading</div> -->
        <svg
          version="1.1"
          id="L5"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          enable-background="new 0 0 0 0"
          xml:space="preserve"
        >
          <circle fill="#007243" stroke="none" cx="6" cy="50" r="6">
            <animateTransform
              attributeName="transform"
              dur="1s"
              type="translate"
              values="0 15 ; 0 -15; 0 15"
              repeatCount="indefinite"
              begin="0.1"
            />
          </circle>
          <circle fill="#007243" stroke="none" cx="30" cy="50" r="6">
            <animateTransform
              attributeName="transform"
              dur="1s"
              type="translate"
              values="0 10 ; 0 -10; 0 10"
              repeatCount="indefinite"
              begin="0.2"
            />
          </circle>
          <circle fill="#007243" stroke="none" cx="54" cy="50" r="6">
            <animateTransform
              attributeName="transform"
              dur="1s"
              type="translate"
              values="0 5 ; 0 -5; 0 5"
              repeatCount="indefinite"
              begin="0.3"
            />
          </circle>
        </svg>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
svg {
  width: 100px;
  height: 100px;
  margin: 40px;
  display: inline-block;
}

.loader {
  z-index: 20000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 1);
  backdrop-filter: blur(10.8px);
  -webkit-backdrop-filter: blur(10.8px);
  display: flex;
  justify-content: center;

  .loading-box {
    align-self: center;
    margin: -50px 0 0 42px !important;
    .loading-image {
      height: 200px;
      width: auto;
    }

    .txt {
      font-size: 12px;
      text-align: center;
      font-weight: 600;
    }
  }
}
</style>
